export var SUBSCRIPTION_REASON = /* @__PURE__ */ ((SUBSCRIPTION_REASON2) => {
  SUBSCRIPTION_REASON2["CHECKOUT_PAGE_UPSELL_AGREE"] = "checkout_page_upsell_agree";
  SUBSCRIPTION_REASON2["TEXT_OFFER_ACCEPTED"] = "text_offer_accepted";
  SUBSCRIPTION_REASON2["FINALIZE_CHECKOUT"] = "finalize_checkout";
  SUBSCRIPTION_REASON2["MANUAL_SETUP"] = "manual_setup";
  return SUBSCRIPTION_REASON2;
})(SUBSCRIPTION_REASON || {});
